import { IMAGES_CACHE_NAME } from './imageCacheVersion.js';

/**
 * Prefetch + Cache Storage para mosaicos / iconos remotos (Firebase, /images, etc.).
 * Así la 2ª visita (y el SW CacheFirst) los sirven al instante.
 */
export async function cacheImages(urls) {
  const list = [...new Set((urls || []).filter(Boolean))];
  if (!list.length) return;

  const warmBrowser = (url) => {
    const img = new Image();
    img.decoding = 'async';
    img.src = url;
  };

  if (!('caches' in window)) {
    list.forEach(warmBrowser);
    return;
  }

  try {
    const cache = await caches.open(IMAGES_CACHE_NAME);
    await Promise.allSettled(
      list.map(async (url) => {
        try {
          const hit = await cache.match(url);
          if (hit) {
            warmBrowser(url);
            return;
          }
          const res = await fetch(url, { mode: 'cors', credentials: 'omit', cache: 'force-cache' });
          if (res.ok) {
            await cache.put(url, res.clone());
          }
          warmBrowser(url);
        } catch {
          warmBrowser(url);
        }
      })
    );
  } catch {
    list.forEach(warmBrowser);
  }
}
